import classNames from "classnames";
import React from "react";
import "./button.component.scss";

interface ButtonDataProps {
  label: string;
  external?: boolean;
  link: string;
  inactive?: boolean;
  disabled?: boolean;
}

interface Props extends ButtonDataProps {
  className: string;
  bigger?: boolean;
}

const Button: React.FC<Props> = (props) => {
  return (
    <a className={classNames("button", props.className, {"is-bigger": props.bigger, "is-disabled": props.disabled})} target="_blank" rel="noreferrer" href={props.link}>
      <span>{props.label}</span>
    </a>
  );
};

export default Button;
